<template>
  <v-app>
    <go-top></go-top>
    <div style="margin-top: 80px">
          <v-layout row wrap>
            <v-flex xs12 md4 sm4 class="brdr">
              <v-carousel
                       
                        height = "280px"
                        width ="100%"
                        cycle
                        hide-delimiters>
                        <v-carousel-item
    
                        v-for="(item,i) in hotelImage"
                        :key="i"
                        :src="item.src"
                        ></v-carousel-item>
                    </v-carousel>
            </v-flex>
            <v-flex xs12 md4 sm4 style="background-image: linear-gradient(#7b1fa2, #e91e63);background-size:cover">
              <h3 class="enquiry" style="text-align:center;margin-top:45px;margin-bottom:15px;color:white">{{this.hotelName}}</h3>

              <div style="text-align:center" v-if="this.rating === 0">
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 1">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 1.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 2">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 2.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 3">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 3.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 4">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 4.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>
                      <div style="text-align:center" v-if="this.rating === 5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ this.rating }}/5
                        </v-chip>
                      </div>

              <h5 style="text-align:center;margin-top:15px;margin-bottom:15px;color:white">{{this.billingAddress}}</h5>
              <h5 style="text-align:center;margin-top:15px;margin-bottom:15px;color:white">+91 6290398678</h5>

              
            </v-flex>
            <v-flex xs12 md4 sm12 style="text-align:right">
              <img
               src="https://s3.amazonaws.com/edwardtufte.com/Thinking%20Eye/ParisMap.gif" 
               height="280px" width="100%" class="brdr" />
            </v-flex>
          </v-layout>
    </div>
    
   
      <v-layout row wrap>
        <v-flex md12 sm12 xs12>
          
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md12 sm12 xs12>
           <v-tabs dark centered color="#7b1fa2" vertical>
                     <v-tab class="white--text">
                           Profile
                     </v-tab>
                     <v-tab class="white--text">
                            Review
                     </v-tab>

                   <!-- :items="hotels" -->
                     <v-tab-item>
                       <v-layout row wrap>
                         <vue-easy-lightbox
                           :visible="visible"
                           :imgs="imgs"
                           @hide="handleHide"
                         ></vue-easy-lightbox>
                          <v-flex md2 sm2 xs12></v-flex>
                          <v-flex md8 sm8 xs12 style="margin-top:20px;">

                             <v-data-table hide-actions :items="hotels">
                                <template v-slot:items="props" style="margin-bottom:100px">
                                  <td class="hvr" style="border-bottom:none !important;">
                                      <v-container class="form-container swo brdr">
                                        <v-layout row wrap>
                                          <v-flex md12 sm12 xs12 class="_head">
                                            <h4 class="_h4" style="padding-bottom:10px;padding-left:2px">{{props.item.roomCategoryName}}&nbsp;&nbsp;<span style="font-size:12px" class="pd"><v-avatar color="#ff336d" size="20">
                                                      <span style="font-size:15px" class="white--text">{{props.item.availableRoom}}</span>
                                                   </v-avatar>  rooms left</span></h4>
                                            <h4 class="__h4 lineThrough grey--text" style="text-align:right;">INR {{props.item.regularRate}}</h4>
                                            <h4 class="__h4" style="text-align:center">INR {{props.item.actualRate}}</h4>
                                          </v-flex>
                                            
                                          <v-flex md4 sm4 xs12 style="padding-left:20px;padding-right:20px;">
                                            <v-layout row wrap  @click="showMultiple(props.item)" class="logopoint">
                                               <v-flex md12 sm12 xs12 style="padding-bottom:2px">
                                                  <img :src=props.item.src1 width="100%" height="220px" />
                                               </v-flex>
                                               <v-flex xs12 style="width:100%">
                                                 <img style="padding-right:5px" :src=props.item.src2 width="33%" height="70px" />
                                                 <img style="padding-right:5px" :src=props.item.src3 width="33%" height="70px" />
                                                 <img :src=props.item.src4 width="34%" height="70px" />
                                               </v-flex>

                                            </v-layout>
                                            
                                          </v-flex>

                                          <v-flex md8 sm8 xs12 style="padding-left:20px;padding-right:20px;">
                                            <v-layout row wrap>
                                              <v-flex md12 sm12 xs12 style="padding-bottom:10px">
                                             <v-container class="form-container elevation-2" style="border-radius:0%">
                                               
                                               <v-btn class="ma-2 white--text" style="pointer-events: none" depressed color="#ff336d"><v-icon size="20" color="white">reorder</v-icon>&nbsp;&nbsp;Description</v-btn>
                                         
                                               
                                               <h5 v-if="props.item.availableRoom === 0" class="grey--text roomleft res">This room is not available</h5>
                                               <v-btn v-if="props.item.availableRoom > 0" class="ma-2 white--text roomleft res" depressed color="indigo" @click="bookNow(props.item)">BOOK NOW</v-btn>
                                                
                                               <v-btn class="ma-2 roomleft res" outline color="#ff336d" @click.stop="enquiryDialog = true">
                                                   Enquiry Now</v-btn>
                                                    <v-dialog
                                                       v-model="enquiryDialog"
                                                       persistent
                                                       max-width="400"
                                                       >
    
      <v-card style="background-color: #ffffff" class="redius">
         
        <div style="color:red">
        

                              <div class="login-form">
                                <v-form ref="form3" v-model="valid" lazy-validation>
                                 <v-card flat color="transparent">
                                   <v-icon style="float:right" color="black" @click.stop="enquiryDialog = false">clear</v-icon><br/>
                                   <v-text-field v-model="form3.fullName" label="Enter your name *" :rules="emptyRule" required></v-text-field>
                                   <v-text-field type="Number" v-model="form3.mobileNumber" label="Mobile number *" :rules="[rules.phNo]" required></v-text-field>
                                    <v-text-field v-model="form3.email" label="Email ID"></v-text-field>
                                   <v-btn color="#ff336d" class="white--text" :disabled="isEnquiry" @click="onEnquiry(props.item)" large block depressed>
                                     <v-icon color="white">check_circle</v-icon>&nbsp;&nbsp;SUBMIT
                                   </v-btn>
                                 </v-card>
                               </v-form>
                              </div>

      </div>
      <br/>
      </v-card>
     </v-dialog>
     <v-dialog v-model="stateDialog" persistent max-width="500px">
                           <v-card>
        <v-card-title
          class="headline white--text"
          style="background-image: linear-gradient(#e91e63, #7b1fa2);background-size:cover;"
          primary-title
        >
          Add Your State
        </v-card-title>

        <v-card-text>
         <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-autocomplete
                             v-model="selectedState"
                             :items="state"
                             label="Select State *"
                             item-text="stateName"
                             item-value="id"
                             :rules="inputRules"
                             required
                             clearable
                            ></v-autocomplete>
            </v-flex>
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
       
          <v-btn
            color="primary"
            text
            :loading="submitBtn"
            @click="submit()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
                         </v-dialog>

                                               
                                               <p style="padding-top:20px">
                                                <read-more more-str="read more" :text="props.item.description" link="#" less-str="read less" :max-chars="250"></read-more>
                                               </p>
                                             </v-container>
                                             </v-flex>

                                             <v-flex md12 sm12 xs12 style="padding-bottom:10px">
                                             <v-container class="form-container elevation-2" style="border-radius:0%">
                                               <v-layout row wrap>
                                                 <v-flex md4 sm4 xs12>
                                                   <span style="font-size:12px"><v-icon size="15px">check</v-icon>&nbsp;Room Size:&nbsp;&nbsp;{{props.item.roomSize}} sq.ft.</span>
                                                 </v-flex>
                                                 <v-flex md3 sm3 xs12>
                                                   <span style="font-size:12px"><v-icon size="15px">check</v-icon>&nbsp;Bed Size:&nbsp;&nbsp;{{props.item.bedSize}}</span>
                                                 </v-flex>
                                                 <v-flex md3 sm3 xs12>
                                                   <span v-if="props.item.fullTimeService === true" style="font-size:12px"><v-icon size="15px">check</v-icon>&nbsp;Room Service</span>
                                                 </v-flex>

                                                 <v-flex md2 sm2 xs12>
                                                   <span style="font-size:12px" class="primary--text logopoint" @click.stop="aboutRoom = true; aboutRoom1(props.item)">More...</span>
                                                 </v-flex>

                        <v-dialog
                             v-model="aboutRoom"
                             max-width="550"
                        >
    
                                <v-card style="background-color: #ffffff" class="redius">
                                  <div style="color:red">

                                <v-card flat color="transparent">
                                  <v-layout row wrap>
                                    <v-flex xs12 md12 sm12>
                                      <h4 style="text-align:left;color:#ff336d;padding-left: 15px"><u>About this Room</u></h4>
                                    </v-flex>
                                <v-flex xs12 md4 sm4 style="padding-right: 5px;padding-left: 15px">
                                   <span style="font-size:12px"><v-icon size="15px">check</v-icon>Room Size:&nbsp;&nbsp;{{ about.roomSize }} sq.ft.</span>
                                </v-flex>
                                <v-flex xs12 md4 sm4 style="padding-right: 5px">
                                   <span style="font-size:12px"><v-icon size="15px">check</v-icon>Bed Size:&nbsp;&nbsp;{{ about.bedSize }}</span>
                                </v-flex>
                                <v-flex xs12 md4 sm4>
                                   <span style="font-size:12px"><v-icon size="15px">check</v-icon>Floor Type:&nbsp;&nbsp;{{ about.floorType }}</span>
                                </v-flex>

                                <v-flex xs12 md4 sm4 style="padding-right: 5px;padding-top: 10px;padding-left: 15px">
                                  <span v-if="about.airConditioning === true" style="font-size:12px"><v-icon size="15px">straighten</v-icon>&nbsp;Air Conditioning</span>
                                  <span v-if="about.airConditioning === false" style="font-size:12px"><v-icon size="15px">clear</v-icon>&nbsp;None Air Conditioning</span>
                                 
                                </v-flex>

                                <v-flex xs12 md4 sm4 style="padding-right: 5px;padding-top: 10px">
                                   <span v-if="about.fullTimeService === true" style="font-size:12px"><v-icon size="15px">room_service</v-icon>&nbsp;24 Hour Service</span>
                                </v-flex>

                                

                                <v-flex xs12 md4 sm4 style="padding-top: 10px">
                                   <span v-if="about.balcony === true" style="font-size:12px"><v-icon size="15px">inbox</v-icon>&nbsp;Balcony</span>
                                </v-flex>

                                <v-flex xs12 md4 sm4 style="padding-right: 5px;padding-top: 10px;padding-left: 15px">
                                   <span v-if="about.seatingArea === true" style="font-size:12px"><v-icon size="15px">airline_seat_recline_normal</v-icon>&nbsp;Seating Area</span>
                                </v-flex>

                              </v-layout>
                                  
                                 </v-card>
         
                              
                     </div>
                    <br/>
                     </v-card>
                    </v-dialog>

                                               </v-layout>
                                             </v-container>
                                             </v-flex>
                                             </v-layout>
                                          </v-flex>
                                         
                                         <v-flex md12 sm12 xs12 style="padding-left:5 px;padding-right:5px;">
                                           <v-container class="form-container elevation-2 _aminities swo" style="border-radius:0%">
                                               <p style="text-align:center;margin-bottom:0px;margin-top:-23px;color:#ff336d">
                                                 Amenities
                                               </p>
                                               
                                                <v-layout row wrap style="text-align:center">
                                                    <v-flex md1 sm1 xs3 style="padding-right:5px" v-if="props.item.breakfast === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>emoji_food_beverage</v-icon>
                                                      </v-btn>
                                                      <p>Breakfast</p>
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs3 style="padding-right:5px" v-if="props.item.parkingPlace === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>local_taxi</v-icon>
                                                      </v-btn>
                                                      <p>Parking</p>
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs3 style="padding-right:5px" v-if="props.item.bathroom === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>bathtub</v-icon>
                                                      </v-btn>
                                                      <p>Bathroom</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.telephone === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>phone</v-icon>
                                                      </v-btn>
                                                      <p>Telephone</p>
                                                    </v-flex>

                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.chair === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>event_seat</v-icon>
                                                      </v-btn>
                                                      <p>Chair</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.powerBackUp === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>power</v-icon>
                                                      </v-btn>
                                                      <p>PowerBackup</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.blanket === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>airline_seat_individual_suite</v-icon>
                                                      </v-btn>
                                                      <p>Blanket</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.dustbins === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>storefront</v-icon>
                                                      </v-btn>
                                                      <p>Dustbin</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.restaurant === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>restaurant</v-icon>
                                                      </v-btn>
                                                      <p>Restaurant</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.wiFi === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>wifi</v-icon>
                                                      </v-btn>
                                                      <p>Wi-Fi</p>
                                                    </v-flex>
                                                    <v-flex class="res" md1 sm1 xs3 style="padding-right:5px" v-if="props.item.tv === true">
                                                      <v-btn small outline fab color="indigo" style="pointer-events:none">
                                                        <v-icon>tv</v-icon>
                                                      </v-btn>
                                                      <p>TV</p>
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs3 style="padding-right:5px">
                                                      <v-btn small outline fab @click.stop="amenities = true; amenities1(props.item)" color="indigo">
                                                        <v-icon>add</v-icon>
                                                      </v-btn>
                                                      <p>More...</p>
                                                    </v-flex>
                                                    <v-flex md12 sm12 xs12>
                                                      <h5 v-if="props.item.availableRoom === 0" class="grey--text man">This room is not available</h5>
                                                      <v-btn class="ma-2 man" outline color="#ff336d" @click.stop="enquiryDialog = true">
                                                   Enquiry Now</v-btn>
                                                   <v-btn v-if="props.item.availableRoom > 0" class="ma-2 white--text man" depressed color="indigo" @click="bookNow(props.item)">BOOK NOW</v-btn>

                                                 </v-flex>
                                                     
                                                     
                        <v-dialog
                             v-model="amenities"
                             max-width="650"
                        >
    
                                <v-card style="background-color: #ffffff" class="redius">
                                  <div style="color:red">

                                <v-card flat color="transparent">
                                  <v-layout row wrap style="padding-left: 15px">
                                    <v-flex xs12 md12 sm12>
                                      <h4 style="text-align:left;color:#ff336d"><u>Amenities for this Room</u></h4>
                                    </v-flex>
                                <v-flex xs12 md3 sm3 style="padding-right: 5px" v-if="amenity.breakfast === true">
                                   <span style="font-size:12px"><v-icon size="15px">emoji_food_beverage</v-icon>&nbsp;Breakfast</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3 style="padding-right: 5px" v-if="amenity.parkingPlace === true">
                                   <span style="font-size:12px"><v-icon size="15px">local_taxi</v-icon>&nbsp;Parking</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3  style="padding-right: 5px" v-if="amenity.bathroom === true">
                                   <span style="font-size:12px"><v-icon size="15px">bathtub</v-icon>&nbsp;Bathroom</span>
                                </v-flex>

                                <v-flex xs12 md3 sm3 v-if="amenity.telephone === true">
                                  <span style="font-size:12px"><v-icon size="15px">phone</v-icon>&nbsp;Telephone</span>
                                </v-flex>

                                <!-- ============================= 1 ================================ --->

                                <v-flex xs12 md3 sm3 style="padding-right: 5px;padding-top: 10px" v-if="amenity.chair === true">
                                   <span style="font-size:12px"><v-icon size="15px">event_seat</v-icon>&nbsp;Chair</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3 style="padding-right: 5px;padding-top: 10px" v-if="amenity.powerBackUp === true">
                                   <span style="font-size:12px"><v-icon size="15px">power</v-icon>&nbsp;PowerBackup</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3  style="padding-right: 5px;padding-top: 10px" v-if="amenity.blanket === true">
                                   <span style="font-size:12px"><v-icon size="15px">airline_seat_individual_suite</v-icon>&nbsp;Blanket</span>
                                </v-flex>

                                <v-flex xs12 md3 sm3 style="padding-top: 10px" v-if="amenity.dustbins === true">
                                  <span style="font-size:12px"><v-icon size="15px">storefront</v-icon>&nbsp;Dustbin</span>
                                </v-flex>
                                <!-- ============================= 2 ================================ --->

                                <v-flex xs12 md3 sm3 style="padding-right: 5px;padding-top: 10px" v-if="amenity.restaurant === true">
                                   <span style="font-size:12px"><v-icon size="15px">restaurant</v-icon>&nbsp;Restaurant</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3 style="padding-right: 5px;padding-top: 10px" v-if="amenity.wiFi === true">
                                   <span style="font-size:12px"><v-icon size="15px">wifi</v-icon>&nbsp;Wi-Fi</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3  style="padding-right: 5px;padding-top: 10px" v-if="amenity.tv === true">
                                   <span style="font-size:12px"><v-icon size="15px">tv</v-icon>&nbsp;TV</span>
                                </v-flex>

                                <v-flex xs12 md3 sm3 style="padding-top: 10px" v-if="amenity.bar === true">
                                  <span style="font-size:12px"><v-icon size="15px">bar</v-icon>&nbsp;Bar</span>
                                </v-flex>


                                <!-- ============================= 3 ================================ --->

                                <v-flex xs12 md3 sm3 style="padding-right: 5px;padding-top: 10px" v-if="amenity.restaurant === true">
                                   <span style="font-size:12px"><v-icon size="15px">restaurant</v-icon>&nbsp;Restaurant</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3 style="padding-right: 5px;padding-top: 10px" v-if="amenity.wiFi === true">
                                   <span style="font-size:12px"><v-icon size="15px">wifi</v-icon>&nbsp;Wi-Fi</span>
                                </v-flex>
                                <v-flex xs12 md3 sm3  style="padding-right: 5px;padding-top: 10px" v-if="amenity.tv === true">
                                   <span style="font-size:12px"><v-icon size="15px">tv</v-icon>&nbsp;TV</span>
                                </v-flex>

                                <v-flex xs12 md3 sm3 style="padding-top: 10px" v-if="amenity.bar === true">
                                  <span style="font-size:12px"><v-icon size="15px">bar</v-icon>&nbsp;Bar</span>
                                </v-flex>

                                

                              </v-layout>
                                  
                                 </v-card>
         
                              
                     </div>
                    <br/>
                     </v-card>
                    </v-dialog>
                                                </v-layout>
                                             </v-container>
                                         </v-flex>

                                       
                                        
                                        </v-layout>
                              </v-container>
                                  </td>
                                </template>
                             </v-data-table>
                            
                          </v-flex>
                          <v-flex md2 sm2 xs12></v-flex>
                       </v-layout>
                                     
                     </v-tab-item>
                     <v-tab-item>dd</v-tab-item>
           </v-tabs>
        </v-flex>
      </v-layout>
  </v-app>
</template>

<script>
import config from "./../../config.json";
import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';
export default {
    components: {
      VueEasyLightbox,
      GoTop
  },
  data() {
    return {
        dialog: false,
        isEnquiry: false,
        enquiryDialog: false,
        stateDialog: false,
        submitBtn: false,
        loggedInUserID: sessionStorage.loggedInUserID,
        aboutRoom: false,
        amenities: false,
        entries: [],
        hotels: [],

        imgs: '',  // Img Url , string or Array
        visible: false,
        index: 0,  // default\

      valid: true,
      inputRules: [v => !!v || "This is empty !!"],
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        /* phNo: value => {
          const pattern = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/;
          return pattern.test(value) || "10 digit number";
        }, */
      },
      city: sessionStorage.city,
      

      hotelName: null,
      billingAddress: null,
      rating: null,
      
      passwordShow: false,
      isLoading: false,
      form: {
      },

      about: {
        roomSize: null,
        bedSize: null,
        floorType: null,
        balcony: null,
        seatingArea: null,
        airConditioning: null,
        fullTimeService: null
      },

      amenity: {
        swimmingPool: null,
        powerBackUp: null,
        parkingPlace: null,
        restaurant: null,
        bar: null,
        spa: null,
        indoorActivites: null,
        outdoorActivities: null,
        kidPlayArea: null,
        wiFi: null,
        electricKettle: null,
        ironIroningBoard: null,
        workDesk: null,
        chargingPoint: null,
        readingLamp: null,
        electronicSafe: null,
        bathtub: null,
        shoeShine: null,
        dailyHousekeeping: null,
        bathroom: null,
        fullTimeInRoomDining: null,
        laundryService: null,
        telephone: null,
        hangers: null,
        chair: null,
        clothesRack: null,
        tv: null,
        refrigerator: null,
        hairdryer: null,
        dentalKit: null,
        towels: null,
        showerCap: null,
        slippers: null,
        bathrobes: null,
        sanitaryBin: null,
        toiletries: null,
        westernToiletSeat: null,
        bathroomPhone: null,
        dustbins: null,
        toiletPaper: null,
        hotColdWater: null,
        newspaper: null,
        magnifyingGlass: null,
        safe: null,
        sewingKit: null,
        showerStanding: null,
        breakfast: null,
        blanket: null,
        pillows: null,
        cushions: null,
        gardenView: null,
        seaView: null,
        hillView: null
      },

      src: {
        src1: null,
        src2: null,
        src3: null,
        src4: null,
        src5: null,
        src6: null,
        src7: null,
        src8: null,
        src9: null,
        src10: null
      },


      form1: {
          name: null
      },
      form3: {
        fullName: null,
        mobileNumber: null,
        email: null
      },

      selectedState: null,
      state: null,

      hotelImage: [],

      stateCode: null,

      roomImage: [],


    };
  },
  
  mounted() {
       this.axios
      .get(config.API + `ViewHotelDetails/${this.$route.params.id}`, {
      })
      .then(res => {
        this.hotelName = res.data.hotelName;
        this.billingAddress = res.data.billingAddress;
        this.rating = res.data.rating;

        this.hotelImage = res.data.hotelImage;

        this.hotels = res.data.details;
      })

      this.axios
      .get(config.API + `States1`, {
      })
      .then(res => {
        this.state = res.data;
      })

      this.getUserData();

        
  },

 methods: {

   getUserData() {
     this.axios
        .get(config.API + "UserDetails/" + sessionStorage.loggedInUserID, {
        })
        .then(res => {
          this.stateCode = res.data.stateCode;
          this.getUserData();
        })
        /* .catch(err => {
          console.log(err.message);
          //this.$toaster.error(err.message);
          this.$Progress.fail();
        }); */
   },

   showMultiple(item) {
     this.axios
        .get(config.API + "RoomImageShow/" + item.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.src.src1 = res.data.src1;
          this.src.src2 = res.data.src2;
          this.src.src3 = res.data.src3;
          this.src.src4 = res.data.src4;
          this.src.src5 = res.data.src5;
          this.src.src6 = res.data.src6;
          this.src.src7 = res.data.src7;
          this.src.src8 = res.data.src8;
          this.src.src9 = res.data.src9;
          this.src.src10 = res.data.src10;
          this.imgs = [this.src.src1, this.src.src2, res.data.src3, res.data.src4, res.data.src5, res.data.src6, res.data.src7, res.data.src8, res.data.src9, res.data.src10]
          this.index = 1  // index of imgList
          this.show()
        })
        /* .catch(err => {
          console.log(err.message);
          //this.$toaster.error(err.message);
          this.$Progress.fail();
        }); */
      
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },

   login() {
     this.$router.push(`/login`);
   },

   room(item) {
     this.axios
      .get(config.API + "RoomImageShow/" + item.id, {
      })
      .then(res => {
        this.roomImage = res.data.imageLink;
        this.hotelData3.hotelCode = res.data.hotelCode;
        this.hotelData3.hotelName = res.data.hotelName;
      })
      /* .catch(err => {
        console.log(err.message);
      }); */
   },

   main() {
     this.$router.push(`/aimro`);
   },

   contactus() {
     this.$router.push(`/contactUs`);
   },
   aboutUs() {
     this.$router.push(`/aboutUs`);
   },
   management() {
     this.$router.push(`/management`);
   },
   paymentSecurity() {
     this.$router.push(`/paymentSecurity`);
   },
   privacyPolicy() {
     this.$router.push(`/privacyPolicy`);
   },
   termsUse() {
     this.$router.push(`/termsUse`);
   },

   bookNow(item) {
     if (sessionStorage.loggedInUserID != null) {
       if (this.stateCode != 0) {
         this.$router.push(`reviewBooking/${item.id}`);
       }
       else {
         this.stateDialog = true;
       }
     }
     else {
      this.$toaster.error("To make this booking first login yourself");
     }
   },

   submit() {
     if (this.$refs.form.validate()) {
       this.submitBtn = true;
        this.axios
          .put(
            config.API + `States1/${sessionStorage.loggedInUserID}`,
            {
              id: this.$route.params.id,
              stateCode: this.selectedState
            }
          )
          .then(() => {
            this.$toaster.success("State Updated");
            this.stateDialog = false;
            this.submitBtn = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.submitBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
        this.submitBtn = false;
      }
   },

   aboutRoom1(item) {
    this.axios
      .get(config.API + "RateAmenities1/" + item.id, {
      })
      .then(res => {
        this.about.roomSize = res.data.roomSize;
        this.about.bedSize = res.data.bedSize;
        this.about.fullTimeService = res.data.fullTimeService;
        this.about.floorType = res.data.floorType;
        this.about.balcony = res.data.balcony;
        this.about.seatingArea = res.data.seatingArea;
        this.about.airConditioning = res.data.airConditioning
      })
      /* .catch(err => {
        console.log(err.message);
      }); */
   },

   amenities1(item) {
    this.axios
      .get(config.API + "RateAmenities1/" + item.id, {
      })
      .then(res => {
        this.amenity.swimmingPool = res.data.swimmingPool;
        this.amenity.powerBackUp = res.data.powerBackUp;
        this.amenity.parkingPlace = res.data.parkingPlace;
        this.amenity.restaurant = res.data.restaurant
        this.amenity.bar = res.data.bar;
        this.amenity.spa = res.data.spa;
        this.amenity.indoorActivites = res.data.indoorActivites;
        this.amenity.outdoorActivities = res.data.outdoorActivities;
        this.amenity.kidPlayArea = res.data.kidPlayArea;
        this.amenity.wiFi = res.data.wiFi;
        this.amenity.electricKettle = res.data.electricKettle;
        this.amenity.ironIroningBoard = res.data.ironIroningBoard;
        this.amenity.workDesk = res.data.workDesk;
        this.amenity.chargingPoint = res.data.chargingPoint;
        this.amenity.readingLamp = res.data.readingLamp;
        this.amenity.electronicSafe = res.data.electronicSafe;
        this.amenity.bathtub = res.data.bathtub;
        this.amenity.shoeShine = res.data.shoeShine;
        this.amenity.dailyHousekeeping = res.data.dailyHousekeeping;
        this.amenity.bathroom = res.data.bathroom;
        this.amenity.fullTimeInRoomDining = res.data.fullTimeInRoomDining;
        this.amenity.laundryService = res.data.laundryService;
        this.amenity.telephone = res.data.telephone;
        this.amenity.hangers = res.data.hangers;
        this.amenity.chair = res.data.chair;
        this.amenity.clothesRack = res.data.clothesRack;
        this.amenity.tv = res.data.tv;
        this.amenity.refrigerator = res.data.refrigerator;
        this.amenity.hairdryer = res.data.hairdryer;
        this.amenity.dentalKit = res.data.dentalKit;
        this.amenity.towels = res.data.towels;
        this.amenity.showerCap = res.data.showerCap;
        this.amenity.slippers = res.data.slippers;
        this.amenity.bathrobes = res.data.bathrobes;
        this.amenity.sanitaryBin = res.data.sanitaryBin;
        this.amenity.toiletries = res.data.toiletries;
        this.amenity.westernToiletSeat = res.data.westernToiletSeat;
        this.amenity.bathroomPhone = res.data.bathroomPhone;
        this.amenity.dustbins = res.data.dustbins;
        this.amenity.toiletPaper = res.data.toiletPaper;
        this.amenity.hotColdWater = res.data.hotColdWater;
        this.amenity.newspaper = res.data.newspaper;
        this.amenity.magnifyingGlass = res.data.magnifyingGlass;
        this.amenity.safe = res.data.safe;
        this.amenity.sewingKit = res.data.sewingKit;
        this.amenity.showerStanding = res.data.showerStanding;
        this.amenity.breakfast = res.data.breakfast;
        this.amenity.blanket = res.data.blanket;
        this.amenity.pillows = res.data.pillows;
        this.amenity.cushions = res.data.cushions;
        this.amenity.gardenView = res.data.gardenView;
        this.amenity.seaView = res.data.seaView;
        this.amenity.hillView = res.data.hillView;   
       })
      /* .catch(err => {
        console.log(err.message);
      }); */
   },


   onSubmit() {
        this.isLoading = true;
      let UserName = this.form.UserName;
      let Password = this.form.Password;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(() => {
          setTimeout(() => {
            this.$toaster.success("Login successfull");
            this.isLoading = false;
            this.$router.push("/_");
          }, 1000);
        })
        .catch(err => {
          this.$toaster.error(err);
          this.isLoading = false;
        });
    },

    onEnquiry(item) {
      this.isEnquiry = true;
      if (this.$refs.form3.validate()) {
        this.axios
          .post(
            config.API + `HotelEnquiries`,
            {
              hotelId: item.hotelId,
              roomCategoryId: item.roomCategoryId,
              fullName: this.form3.fullName,
              mobileNumber: this.form3.mobileNumber,
              email: this.form3.email
            }
          )
          .then(() => {
            this.$toaster.success("Thanks for your enquiry we will contact you soon.");
            this.enquiryDialog = false;
            this.isEnquiry = false;
            this.form3.fullName = null;
            this.form3.mobileNumber = null;
            this.form3.email = null
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.isEnquiry = false;
          });
      }
      else {
        this.$toaster.error(`Required field are empty!!`);
        this.isEnquiry = false;
      }
     
    }
 }
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
._aminities {
  height: 100px;
}
.brdr {
  border: 1px solid #000000;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
._head {
  width: 100%;
}
._h4 {
  width: 60%;
  float: left;
}
.__h4 {
  width: 20%;
  float: left;
}
.lineThrough {
  text-decoration: line-through;
}
.form-container {
  margin: 0px !important;
}
.roomleft {
  float: right;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
  .pd {
    padding-left: 50px !important;
  }
  ._aminities {
    height: 150px;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
  /* .pd {
    padding-left: 100px !important;
  } */
}
</style>
